import DelegateSlideIn, {
  ManagerInfo as _ManagerInfo
} from './ManagerSlideIn';
export default DelegateSlideIn;
export type ManagerInfo = _ManagerInfo;
